import { render, staticRenderFns } from "./Ups.vue?vue&type=template&id=853d8860&"
import script from "./Ups.vue?vue&type=script&lang=js&"
export * from "./Ups.vue?vue&type=script&lang=js&"
import style0 from "./Ups.vue?vue&type=style&index=0&id=853d8860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports